import React, { useState, useEffect, useCallback, useMemo } from 'react';
import CouponModalStyled from './CouponModalStyled';
import { TextField, Box, Button, useTheme } from '@material-ui/core';
import { useDispatch, useSelector } from 'dva';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useIntl } from 'umi';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const [allCpList, setAllCpList] = useState([]);
  const [defaultCouponList, setDefaultCouponList] = useState([]);
  const [isRefresh, setIsRefresh] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const dispatch = useDispatch();
  const { setOpen = () => {}, onConfirm, couponList } = props;
  useEffect(() => {
    if (couponList && couponList.length > 0) {
      setDefaultCouponList(couponList);
      setSelectedCouponList(couponList);
    }
  }, []);

  const [pageData, setPageData] = useState({
    pageSize: 8,
    pageNum: 1,
  });

  const couponIdList = useMemo(() => {
    return couponList?.map((i) => i.id);
  }, [couponList]);

  const [selectedCouponList, setSelectedCouponList] = useState([]);

  const [couponTitle, setCouponTitle] = useState('');

  const fetchCouponList = useCallback(() => {
    dispatch({
      type: 'cpList/getCpList',
      payload: {
        values: {
          pageNum: pageData.pageNum,
          pageSize: pageData.pageSize,
          status: 'NOT_COMPLETE',
          title: isSearch ? couponTitle : null,
        },
      },
    });
  }, [dispatch, pageData, isRefresh]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  const {
    data: cpList,
    total,
    pages,
  } = useSelector((state) => state.cpList?.cpList) || {};
  console.log({ cpList });
  useEffect(() => {
    if (cpList?.length > 0) {
      setAllCpList([...allCpList, ...cpList]);
    }
  }, [cpList, setAllCpList]);
  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b, c) => {
        const currentId = b.id;
        let Index = -1;
        defaultCouponList.map((i, index) => {
          if (i.id === currentId) {
            Index = index;
          }
        });
        const copyDefaultCouponList = [...defaultCouponList];
        if (Index >= 0) {
          copyDefaultCouponList.splice(Index, 1);
          setDefaultCouponList([...copyDefaultCouponList]);
        }

        // const pageDataIds = cpList.map((item) => item.id); //当前分页的id数组
        //根据id 筛选出最新选中的值
        function unique(arr) {
          return Array.from(new Set(arr));
        }
        //去重一下
        const uAllCpList = unique(allCpList);
        //去重一下
        let z = [];
        for (let i = 0; i < c.length; i++) {
          const cpItem = uAllCpList.find((item) => item.id === c[i].id);
          cpItem.givenNum = '1';
          if (cpItem) {
            z.push(cpItem);
          }
        }
        // const z = x.filter((i) => y.find((item) => item.id === i));

        const t = [...z, ...copyDefaultCouponList];

        function unique1(arr) {
          for (let i = 0; i < arr.length; i++) {
            for (let j = i + 1; j < arr.length; j++) {
              if (arr[i].id === arr[j].id) {
                //第一个等同于第二个，splice方法删除第二个
                arr.splice(j, 1);
                j--;
              }
            }
          }
          return arr;
        }
        const array = unique1(t);
        setSelectedCouponList(array);
      },
    },
    {
      title: '优惠券ID',
      align: 'left',
      id: 'id',
      key: 'id',
      width: 100,
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl03' }),
      align: 'left',
      id: 'title',
      key: 'title',
      width: 225,
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl08' }),
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      width: 100,
    },
    {
      title: formatMessage({ id: 'marketing.people.regnotcon.d01.lbl07' }),
      align: 'left',
      id: 'isLimitMaxCoupons',
      key: 'isLimitMaxCoupons',
      width: 100,
      render: ({ isLimitMaxCoupons }) => {
        return <div>{isLimitMaxCoupons ? '限制' : '不限'}</div>;
      },
    },
    //赠券数
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    onConfirm(selectedCouponList);
    setOpen(false);
  };

  const footContent = (
    <div className="modal-btn-wrap">
      <Button onClick={handleClose} variant="contained" color="secondary">
        {formatMessage({ id: 'comm.action.btn.08' })}
      </Button>
      <Button
        variant="contained"
        type="submit"
        className="btnSubmit button"
        onClick={onSubmit}
      >
        {formatMessage({ id: 'comm.action.btn.07' })}
      </Button>
    </div>
  );
  const handleRestClick = () => {
    setIsSearch(false);
    setCouponTitle('');
    setPageData({ ...pageData, pageNum: 1 });
    setIsRefresh(isRefresh + 1);
  };
  return (
    <CouponModalStyled theme={theme}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 32px',
        }}
      >
        <Box className="coupon-name-wrap">
          <Box sx={{ color: '#212121', fontSize: '18px', fontWeight: '600' }}>
            选择优惠券
          </Box>
          <TextField
            className="coupon-name"
            variant="standard"
            onChange={(e) => {
              setCouponTitle(e.target.value);
              setIsSearch(false);
            }}
            value={couponTitle}
            label="优惠券名称"
            placeholder={formatMessage({
              id: 'marketing.people.regnotcon.d01.placeholder01',
            })}
          />
        </Box>
        <Box
          className="button-group"
          sx={{
            display: 'flex',
            gap: '6px',
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            className="reset"
            onClick={handleRestClick}
            startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
          >
            {formatMessage({ id: 'comm.action.btn.06' })}
          </Button>

          <Button
            variant="contained"
            className="search"
            startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={() => {
              setPageData({ ...pageData, pageNum: 1 });
              setIsRefresh(isRefresh + 1);
              setIsSearch(true);
            }}
          >
            {formatMessage({ id: 'comm.action.btn.01' })}
          </Button>
        </Box>
      </Box>
      <div className="coupon-list">
        <DataTableNativeML
          columns={columns}
          changePage={changePage}
          page={pageData}
          data={cpList}
          total={total}
          devicesMinWidth="auto"
          chooseIds={couponIdList}
          paging={true}
          columnKey="id"
          FootContent={footContent}
          initP={true}
          hasNext={cpList?.length === pageData.pageSize}
          showPagingData={{ status: true, marginTop: '24px' }}
          showPageColor={true}
          pages={pages}
          np={true}
        ></DataTableNativeML>
      </div>
    </CouponModalStyled>
  );
};
